import * as React from "react";

import { cn } from "@frontend/shared/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: "empty" | "filled";
}

const classNames =
  "w-1/3 rounded-xl border-transparent focus:border-superscriptBlue focus:border-2 bg-gray-100 p-3 m-1 focus:outline-none focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 transition-all duration-300 placeholder:text-gray-400 font-light placeholder:font-light";
const filledClassNames = "border bg-white border-black";

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          variant === "empty" && classNames,
          variant === "filled" && `${classNames} ${filledClassNames}`,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
